import React from 'react'
import HeaderOne from '../../components/Partials/Headers/HeaderOne';
import Footer from '../../components/Partials/Footers/HomeFour/Footer';
import PolicePosts from './PolicePosts';
import useToggle from "../../Hooks/useToggle.js";
import Drawer from "../../components/Mobile/Drawer";
import { navigations } from "../../Data/navigation.js";



 function Police() {
  const [drawer, setDrawer] = useToggle(false);
    const navigationData = navigations;
  return (
    <div>
         <Drawer
        drawer={drawer}
        action={setDrawer.toggle}
        navigationData={navigationData}
      />
      <HeaderOne drawerAction={setDrawer.toggle}/>
      <PolicePosts/>
 <Footer/>
    </div>
  )
}
export default Police;